import SC from "./style";
import { useState, useEffect, useRef } from "react";
import { apiPost } from "api/callApi";
import { Button, Label, Loader } from "InnoUI/components";
import theme from "theme";
import InnoIcons from "InnoUI/innoicons";

import { convertBase64 } from "utils/config";
import { InputField } from "components";
import { showAlert } from "utils/helper";
import { useNavigate } from "react-router";

const AddLevel = (props) => {
  const {
    onClose = () => {},
    projectdata,
    isEditing,
    projectId,
    setProjects = () => {},
    reload = false,
    setSelectedTab = () => {},
  } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    image: "",
  });
  const navigate = useNavigate();

  const fileInputRef = useRef(null);

  useEffect(() => {
    if (isEditing && projectdata) {
      const updatedData = { ...projectdata };
      updatedData.adminStatus = updatedData.userType !== 2;
      setData(updatedData);
    }
  }, [isEditing, projectdata]);

  const handleChange = (property, value) => {
    setData((prev) => ({
      ...prev,
      [property]: value,
    }));
  };

  const handleRemoveImage = (type) => {
    setData((prevData) => ({
      ...prevData,
      [type]: "",
    }));
  };

  const handleImageChange = async (e, type) => {
    const file = e.target.files[0];
    try {
      const base64Image = await convertBase64(file, 5 * 1024 * 1024);
      setData((prevData) => ({
        ...prevData,
        [type]: base64Image.preview,
      }));
    } catch (error) {
      alert(error);
    } finally {
      e.target.value = "";
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const endpoint = isEditing
      ? `/v1/levels/${projectdata.id}`
      : `/v1/${projectId}/levels`;
    try {
      const response = await apiPost(endpoint, data);

      showAlert({ title: "Success", text: response?.message, icon: "success" });
      setProjects((prevData) =>
        isEditing
          ? prevData.map((level) =>
              level.id == projectdata.id ? response.data : level
            )
          : [response.data, ...prevData]
      );
      onClose();
      setSelectedTab(0);
      if (reload) {
        navigate(0);
      }
    } catch (error) {
      showAlert({
        title: "Error",
        text: error.response?.data?.message || "An error occurred",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SC.DrawerTitlesContainer>
        <SC.DrawerTitles>
          {isEditing ? "Edit Level" : "New Level"}
        </SC.DrawerTitles>
        <SC.CloseIcon>
          <InnoIcons.CloseIcon onClick={onClose} />
        </SC.CloseIcon>
      </SC.DrawerTitlesContainer>
      {loading && <Loader />}
      <SC.Form onSubmit={handleSubmit}>
        <SC.FormWrapper>
          {/* Level Name */}
          <SC.LabelContainer>
            <SC.Label>
              Level Name <SC.Astrik>*</SC.Astrik>
            </SC.Label>
            <SC.Children>
              <SC.Wrapper>
                <InputField
                  name="name"
                  value={data.name}
                  onChange={handleChange}
                  required
                />
              </SC.Wrapper>
            </SC.Children>
          </SC.LabelContainer>

          {/* Select Property */}

          <Label label="Display Image">
            <SC.Wrapper
              style={{ position: "relative", display: "inline-block" }}
            >
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleImageChange(e, "image")}
                style={{ display: "none" }}
                ref={fileInputRef}
              />
              <Button
                caption="Choose file"
                onClick={() => fileInputRef.current.click()}
                fontSize="12px"
                style={{
                  background: "#f3f3f3",
                  color: theme.colors.white,
                  minWidth: "100px",
                  height: "25px",
                  borderRadius: "3px",
                  border: "1px solid #949494",
                  position: "relative",
                  zIndex: "1",
                }}
              />
              <span style={{ fontSize: "11px", marginLeft: "5px" }}>
                Please select a file with size up to 5MB.
              </span>
              {data?.image && (
                <div style={{ display: "flex", marginTop: "5px" }}>
                  <img
                    src={data?.image}
                    alt={""}
                    style={{
                      maxWidth: "50px",
                      maxHeight: "50px",
                      objectFit: "contain",
                    }}
                  />
                  <SC.CloseIconn onClick={() => handleRemoveImage("image")} />
                </div>
              )}
            </SC.Wrapper>
          </Label>

          {/* Button */}
          <SC.ButtonContainer>
            <Button
              caption="Cancel"
              onClick={onClose}
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.colors.cancelButton,
                color: theme.colors.white,
                minWidth: "100px",
                borderRadius: "3px",
                height: "30px",
                fontSize: "12px",
              }}
            />
            <Button
              caption={isEditing ? "Save" : "Add"}
              type="submit"
              isLoading={loading}
              color="white"
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.gradient.themeGradient,
                color: theme.colors.white,
                minWidth: "100px",
                height: "30px",
                borderRadius: "3px",
              }}
            />
          </SC.ButtonContainer>
        </SC.FormWrapper>
      </SC.Form>
    </>
  );
};

export default AddLevel;
